var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStartSelectedEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    fillRule: "evenodd",
    d: "M9.09 1.849l1.02 2.041c.25.491.73.831 1.28.91l2.3.327c1.39.199 1.94 1.876.94 2.839l-1.66 1.589c-.4.382-.59.933-.49 1.472l.39 2.244c.24 1.359-1.22 2.396-2.46 1.755l-2.06-1.06a1.717 1.717 0 0 0-1.575 0l-2.054 1.06c-1.245.641-2.7-.396-2.462-1.755l.392-2.244a1.641 1.641 0 0 0-.488-1.472L.502 7.966c-1.007-.963-.452-2.64.94-2.839L3.739 4.8a1.695 1.695 0 0 0 1.277-.91l1.027-2.041C6.666.612 8.46.612 9.09 1.849z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartSelectedEmpty);
export default __webpack_public_path__ + "static/media/start-selected-empty.c82873cf.svg";
export { ForwardRef as ReactComponent };